/** Position book filter options — realised vs unrealised by net quantity. */
export const POSITION_BOOK_FILTER_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Realised", value: "realised" },
  { label: "Unrealised", value: "unrealised" },
];

export function getPositionNetQuantity(row) {
  const raw = row?.net_quantity ?? row?.net_qty ?? row?.Net_Qty;
  const n = Number(raw);
  return Number.isFinite(n) ? n : 0;
}

/** Closed / squared-off: net qty = 0 (realised PnL). */
export function isRealisedPosition(row) {
  return getPositionNetQuantity(row) === 0;
}

/** Open position: net qty <> 0 (unrealised PnL). */
export function isUnrealisedPosition(row) {
  return getPositionNetQuantity(row) !== 0;
}

export function filterPositionBookRows(rows, filter) {
  if (!Array.isArray(rows)) return [];
  if (filter === "realised") return rows.filter(isRealisedPosition);
  if (filter === "unrealised") return rows.filter(isUnrealisedPosition);
  return rows;
}
